<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mb-4">
            {{ value.label }}
        </h3>
        <p v-if="value.value.lat && value.value.lon">
            {{ value.value.lat }}, {{ value.value.lon }}
        </p>
        <p v-else>{{ $t('error.location.precision') }}</p>
        <p class="mb-4">{{ value.value.address }}</p>
        <l-map v-if="value.value.lat && value.value.lon"
            ref="myMap"
            id="map"
            :zoom="zoom"
            :center="getCenter()"
            class="m-auto w-auto rounded-md"
            style="height: calc(100vh - 600px); z-index: 1"
            @update:zoom="updateZoom($event)"
        >
            <l-tile-layer
                :options="optionsZoom"
                :attribution="attribution"
                :url="url"
            />
            <l-marker :lat-lng="getCoord()"> </l-marker>
        </l-map>
    </div>
</template>

<script>
import { L, latLng } from 'leaflet'
import {
    LMap,
    LTileLayer,
    LGeoJson,
    LPolygon,
    LMarker,
    LPopup,
    LIcon,
    LControl,
    LTooltip
} from 'vue2-leaflet'

export default {
    name: 'MapPostCard',
    components: {
        L,
        LMap,
        LTileLayer,
        LPolygon,
        LMarker,
        LGeoJson,
        LPopup,
        LTooltip,
        LIcon,
        LControl
    },
    props: ['post', 'value'],
    data: function () {
        var center
        return {
            zoom: 16,
            url: `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${this.$store.state.vueAppMapboxAccessToken}`,
            attribution: '&copy; OpenStreetMap, &copy; Mapbox',
            center,
            optionsZoom: {
                maxZoom: 22,
                maxNativeZoom: 20
            }
        }
    },
    methods: {
        updateZoom: function (zoom) {
            this.zoom = zoom
        },
        getCoord: function () {
            return latLng(this.value.value.lat, this.value.value.lon)
        },
        getCenter: function () {
            return [this.value.value.lat, this.value.value.lon]
        }
    }
}
</script>

<style scoped></style>
